import { useCallback, useState } from "react"

const useAsync = () => {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState()
  const [error, setError] = useState()

  const clear = () => {
    setBusy(false);
    setResult(undefined);
    setError(undefined);
  }

  const dispatch = useCallback((callback, options = {}) => {
    clear();

    setBusy(true);

    return callback()
      .then((result) => {
        setResult(result);

        options.onResult && options.onResult(result)

        return Promise.resolve(result);
      })
      .catch((error) => {
        setError(error);

        options.onError && options.onError(error);

        return Promise.reject(error);
      })
      .finally(() => setBusy(false))
  }, []);

  return {
    busy, result, error, dispatch, clear
  }
}

export {
  useAsync
}